<div class="dialog -m-6 flex flex-col">
  <div class="flex h-16 flex-0 items-center justify-between bg-primary px-4">
    <div class="flex items-center gap-2 text-white">
      <span class="text-lg font-semibold">Account Status</span>
    </div>
  </div>

  <div class="overflow-y-auto p-4">
    <div class="flex flex-col items-center gap-6 sm:flex-row sm:items-center sm:gap-8">
      <div class="w-25 flex-0 self-center">
        <img src="assets/img/logo.svg" />
      </div>
      <div class="flex-1 text-center sm:text-left">
        <h4 class="mb-2 text-3xl font-medium text-primary">Thank you for registering to iskaan!</h4>
        <p class="text-lg text-primary">We are setting up your account, you will be notified once your account is activated.</p>
        <div class="mt-5 flex justify-center">
          <button mat-stroked-button color="primary" class="m-1 items-center" (click)="logout()" [disabled]="loading > 0">
            <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
            <span class="ms-2">Logout</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
